import { Controller } from '@hotwired/stimulus'
import { subscribe, unsubscribe } from '@/service/ticker'

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static targets = ['completionTime']
    static values = {
        timestamp: Number,
        lotNumber: Number
    }

    declare timestampValue: number
    declare lotNumberValue: number

    declare completionTimeTarget: HTMLElement
    declare hasCompletionTimeTarget: boolean

    private timestamp: number = 0

    completionTimeTargetConnected() {
        this.timestamp = this.timestampValue ? this.timestampValue : 0
        subscribe(this.handleTick)
    }

    completionTimeTargetDisconnected() {
        unsubscribe(this.handleTick)
    }

    handleTick = (nowEpochSec: number) => {
        const element = this.completionTimeTarget
        const timestamp = this.timestamp

        if (Number.isNaN(timestamp)) {
            return
        }

        const distance = Math.max(0, timestamp - nowEpochSec)

        if (distance < 60 * 60) {
            this.replaceClassName('variant-error-alt')
        } else if (distance < 60 * 60 * 24) {
            this.replaceClassName('variant-warning-alt')
        }

        this.element.classList.remove('invisible')

        if (distance === 0) {
            return element.innerHTML = 'Торги завершены'
        }

        element.innerHTML = `До&nbsp;завершения ${this.formatTimer(distance)}`
    }

    updateTimestamp(timestamp: number) {
        this.timestamp = timestamp
    }

    replaceClassName(className: string) {
        this.element.className = this.element.className.replace(/variant-[a-z\-]*/, className)
    }

    formatTimer(distance: number) {
        const timeConsts = {
            day: 60 * 60 * 24,
            hour: 60 * 60,
            minute: 60
        }

        const days = Math.floor(distance / timeConsts.day)

        if (days > 0) {
            return `${days}&nbsp;${this.getWordCase(days, ['день', 'дня', 'дней'])}`
        }

        const hoursNum = Math.floor((distance % timeConsts.day) / timeConsts.hour)
        const minutesNum = Math.floor((distance % timeConsts.hour) / timeConsts.minute)

        if (hoursNum > 0 && minutesNum > 0) {
            const hoursStr = hoursNum.toString().padStart(2, '0')
            const minutesStr = minutesNum.toString().padStart(2, '0')

            return `${hoursStr}&nbsp;${this.getWordCase(hoursNum, ['час', 'часа', 'часов'])} ${minutesStr}&nbsp;${this.getWordCase(minutesNum, ['минута', 'минуты', 'минут'])}`
        }

        if (hoursNum > 0) {
            const hoursStr = hoursNum.toString().padStart(2, '0')
            return `${hoursStr}&nbsp;${this.getWordCase(hoursNum, ['час', 'часа', 'часов'])}`
        }

        if (minutesNum > 0) {
            const minutesStr = minutesNum.toString().padStart(2, '0')
            return `${minutesStr}&nbsp;${this.getWordCase(minutesNum, ['минута', 'минуты', 'минут'])}`
        }

        return `${distance}&nbsp;${this.getWordCase(distance, ['секунда', 'секунды', 'секунд'])}`
    }

    getWordCase(count: number, title: [string, string, string]) {
        const cases = [2, 0, 1, 1, 1, 2]

        return title[count % 100 > 4 && count % 100 < 20 ? 2 : cases[count % 10 < 5 ? count % 10 : 5]]
    }
}
